/**
 * User-related constants for the Tennis League application
 */

export const USTA_LEVELS = ['2.5', '3.0', '3.5', '4.0', '4.5', '5.0', '5.5'] as const;

export type USTALevel = typeof USTA_LEVELS[number];

export const GENDERS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
] as const;

export type Gender = 'male' | 'female' | 'other';

export const GENDER_LABELS: Record<Gender, string> = {
  male: 'Male',
  female: 'Female',
  other: 'Other',
};

export type TournamentType = 'ladder' | 'round_robin_ladder';

export const TOURNAMENT_TYPE_LABELS: Record<TournamentType, string> = {
  ladder: 'Ladder',
  round_robin_ladder: 'Round Robin Ladder',
};

export const TOURNAMENT_MIN_PLAYERS: Record<TournamentType, number> = {
  ladder: 2,
  round_robin_ladder: 4,
};
